import { Injectable } from '@angular/core';

@Injectable()
export class NativeWindoRefService {

  constructor() { }

  getNativeWindow(): any{
    return window;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/native-windo-ref.service.ts